'use client';

import { useState } from 'react';
import MobileCarousel from 'components/pulsomics/MobileCarousel';
import { FeatureLink } from './FeatureLink';
import { MeasureFeatureMedia } from './MeasureFeatureMedia';
import type { MeasureFeature } from './measureMedia';
import styles from './MeasureFeatureCarousel.module.css';

export function MeasureFeatureCarousel({
  features,
  imageAlt,
  label,
}: {
  features: MeasureFeature[];
  imageAlt: string;
  label: string;
}) {
  const [settled, setSettled] = useState(0);

  return (
    <MobileCarousel label={label} showDots={false} onSettle={setSettled}>
      {features.map((feature, index) => (
        <article key={feature.id} className={styles.card}>
          <div className={styles.media}>
            <MeasureFeatureMedia
              feature={feature}
              imageAlt={imageAlt}
              sizes="320px"
              active={index === settled}
            />
          </div>
          <div className={styles.copy}>
            <h4 className={styles.title}>
              {feature.titleMobile ?? feature.title}
            </h4>
            <p className={styles.body}>{feature.bodyMobile ?? feature.body}</p>
            {feature.link ? (
              <p className={styles.linkRow}>
                <FeatureLink href={feature.link.href}>
                  {feature.link.label}
                </FeatureLink>
              </p>
            ) : null}
          </div>
        </article>
      ))}
    </MobileCarousel>
  );
}
